// extracted by mini-css-extract-plugin
export default {"app":"app_app__ZSdIq","content":"app_content__T+cwl"};